import React from 'react';
import { curry, get } from 'lodash';
import { Query } from 'react-apollo';

import caseDataQuery from './caseDataQuery';
import { CASE_STATUS } from '../constants';

export const buildQueryChild = curry(
  (WrappedComponent, componentProps, { data, loading }) => (
    <WrappedComponent
      {...componentProps}
      caseId={get(data, 'case.id')}
      createdAt={get(data, 'case.createdAt', '')}
      fixpixPushResult={get(data, 'case.fixpixPushResult') || 'NOT_ATTEMPTED'}
      isLoadingCaseStatus={!!loading}
      servicingDealerTimezone={get(
        data,
        'case.servicingDealer.dealer.timezone',
      )}
      status={get(data, 'case.status', CASE_STATUS.new)}
      statusHistory={get(data, 'case.statusHistory', [])}
    />
  ),
);

function buildWrappedComponentWithQuery(WrappedComponent, componentProps) {
  const { caseNumber } = componentProps;

  return (
    <Query skip={!caseNumber} query={caseDataQuery} variables={{ caseNumber }}>
      {buildQueryChild(WrappedComponent, componentProps)}
    </Query>
  );
}

const withCaseData = curry(buildWrappedComponentWithQuery);

export default withCaseData;



// WEBPACK FOOTER //
// ./src/compositions/CaseStatus/withCaseData/index.js